import { getOwaMiniCommonStrings } from 'owa-strings/owa-mini-common-strings';

/**
 * Returns the string to be displayed on the tooltip
 * @param viewProps view props of the tooltip
 */
export const getTooltipContent = viewProps => {
    const strings = getOwaMiniCommonStrings();
    const { titleKey, content } = viewProps;
    if (content) {
        return content;
    } else {
        return strings[titleKey];
    }
};
